import React, { useContext } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  getApplication,
  updateApplication,
  submitApplication,
} from "../models/application";
import Loader from "../components/Loader";

const ApplicationContext = React.createContext();

const Provider = ({ id, children }) => {
  const queryClient = useQueryClient();

  const { data, error, isLoading } = useQuery(["application", id], () =>
    getApplication(id)
  );

  const updateMutation = useMutation(updateApplication, {
    onMutate: async ({ id, ...newData }) => {
      await queryClient.cancelQueries(["application", id]);
      const previous = queryClient.getQueryData(["application", id]);

      queryClient.setQueryData(["application", id], {
        ...previous,
        data: { ...previous?.data, ...newData },
      });

      return { previous, id };
    },
    onError: (error, _, context) => {
      if (error) console.error(error);
      queryClient.setQueryData(["application", context.id], context.previous);
    },
    onSettled: (_, error, context) => {
      if (error) console.error(error);
      queryClient.invalidateQueries(["application", context.id]);
    },
  });

  const onUpdate = (data) => {
    updateMutation.mutate({ id, ...data });
  };

  const onSubmit = async () => {
    await submitApplication(id);

    window.location.replace("/thanks/");
  };

  if (isLoading) return <Loader />;

  if (error || data?.code) {
    return <p>We are unable to take online applications at the moment.</p>;
  }

  return (
    <ApplicationContext.Provider
      value={{
        id,
        data: data?.data || null,
        onUpdate,
        onSubmit,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

export const useApplication = () => useContext(ApplicationContext);

export default Provider;
